import React from 'react';
import PolicyLayout from './PolicyLayout';

const TermsPage: React.FC = () => (
  <PolicyLayout title="Terms and Conditions" lastUpdated="August 1, 2026">
    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using the Sasta Fashions website and services, you accept and agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>
    </section>

    <section>
      <h2>2. Use of the Website</h2>
      <ul>
        <li>You must be at least 18 years old to make a purchase</li>
        <li>You are responsible for maintaining the confidentiality of your account credentials</li>
        <li>You agree not to use our website for any unlawful purpose</li>
        <li>You must not attempt to gain unauthorised access to our systems</li>
      </ul>
    </section>

    <section>
      <h2>3. Product Information</h2>
      <p>We strive to display product colours, sizes, and descriptions as accurately as possible. However, slight variations may occur due to screen display differences. All prices are inclusive of GST as displayed.</p>
    </section>

    <section>
      <h2>4. Pricing and Payment</h2>
      <ul>
        <li>All prices shown are in Indian Rupees (₹) and include applicable taxes</li>
        <li>We reserve the right to change prices at any time without prior notice</li>
        <li>Payment must be completed before order processing begins</li>
        <li>We accept Cash on Delivery and online payments via our secure payment gateway</li>
      </ul>
    </section>

    <section>
      <h2>5. Wallet Terms</h2>
      <ul>
        <li>Wallet balance is non-transferable and non-withdrawable</li>
        <li>Cashback earned is credited automatically based on recharge amount</li>
        <li>Wallet balance can only be used for purchases on Sasta Fashions</li>
        <li>We reserve the right to modify cashback percentages at any time</li>
      </ul>
    </section>

    <section>
      <h2>6. Intellectual Property</h2>
      <p>All content on this website including text, images, logos, and graphics are the property of SASTA DEAL PRIVATE LIMITED and are protected by copyright laws. Unauthorised use is strictly prohibited.</p>
    </section>

    <section>
      <h2>7. Limitation of Liability</h2>
      <p>Sasta Fashions shall not be liable for any indirect, incidental, or consequential damages arising from your use of our website or products. Our maximum liability shall not exceed the amount paid for the specific order in question.</p>
    </section>

    <section>
      <h2>8. Governing Law</h2>
      <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in West Bengal, India.</p>
    </section>

    <section>
      <h2>9. Changes to Terms</h2>
      <p>We reserve the right to update these terms at any time. Continued use of the website after changes constitutes acceptance of the new terms.</p>
    </section>

    <section>
      <h2>10. Contact</h2>
      <p>
        <strong>SASTA DEAL PRIVATE LIMITED</strong><br />
        Floor No. Gr - Fr, Building No. 114/K,<br />
        Raja S.C. Mullick Road, Near Naktala, Garia,<br />
        Kolkata, West Bengal – 700047<br />
        Email: <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong>
      </p>
    </section>
  </PolicyLayout>
);

export default TermsPage;
